import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { TableConfig } from "@app/shared/util/table-config.utils";
import { AppUtils } from "@app/shared/util/app.utils";
import { PagedResponse } from "@models/response.model";
import { Issue } from "@models/issue.model";
import { Log } from "ng2-logger";
import { map } from "rxjs/operators";

@Injectable()
export class IssuesService {
    static readonly ISSUES_API_GET_PATH = `${environment.baseURL}/api/issue`;
    static readonly ISSUES_API_REPORT_DOWNLOAD_PATH = `${environment.baseURL}/api/issue/download`;


    _logger = Log.create(IssuesService.name);

    static adaptIssue(issue) {
        return {
            lineId: issue.line.id,
            toolIds: issue.tools.map(t => t.id),
            reasonId: issue.reason.id,
            description: issue.description,
            isReplacementOrdered: issue.isReplacementOrdered
        }
    }

    constructor(private http: HttpClient) {
    }

    getAllIssues(tableConfig: TableConfig = null) {
        const params = AppUtils.buildPageableParams(tableConfig);
        return this.http.get<PagedResponse<Issue>>(IssuesService.ISSUES_API_GET_PATH, {params: params})
            .pipe(map(this.mapIssues));
    }

    getIssueById(id: number) {
        return this.http.get<Issue>(`${IssuesService.ISSUES_API_GET_PATH}/${id}`)
            .pipe(map(this.mapIssue));
    }

    signalIssue(issue) {
        const apiIssue = IssuesService.adaptIssue(issue);
        this._logger.info('signalIssue:: Adapted issue to', apiIssue);
        return this.http.post<Issue>(IssuesService.ISSUES_API_GET_PATH, apiIssue);
    }

    rejectIssue(issue: Issue) {
        const toolIds = issue.tools.map(x => x.id);
        return this.http.patch<number>(`${IssuesService.ISSUES_API_GET_PATH}/${issue.id}/reject`, { ids: toolIds });
    }

    mapIssues = res => {
        return {
            items: res.items.map(this.mapIssue),
            count: res.total
        };
    };

    mapIssue = res => {
        return new Issue(res);
    }

    downloadIssuesReport(requestConfig: TableConfig = null) {
        const params = AppUtils.buildPageableParams(requestConfig);
        return this.http.get(IssuesService.ISSUES_API_REPORT_DOWNLOAD_PATH,
            {observe: 'response', params: params, responseType: 'blob'});
    }

}
